import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.widget.modal.cage.in');
import { OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import moment from 'moment';

@Component({
    selector: 'wiz-portal-farm-widget-modal-cage-in',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.farm.widget.modal.cage.in/view.scss */
/* src/app/portal.farm.widget.modal.cage.in/view.scss: no such file or directory */`],
})
export class PortalFarmWidgetModalCageInComponent implements OnInit, OnChanges {

    @ViewChild('modalMessage') modalMessage: any;

    @Input() data: any;
    @Output() closed = new EventEmitter<any>();

    public species: any[] = [];
    public form: any = {};
    public closing = false;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) {}

    async ngOnInit() {
        await this.loadSpecies();
        this.initialize();
        await this.service.render();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            this.initialize();
        }
    }

    @HostListener('document:keydown.escape')
    onEscKey() {
        if (!this.closing) this.cancel();
    }

    private async loadSpecies() {
        const res = await wiz.call("species");
        this.species = res.code === 200 ? (res.data || []) : [];
    }

    private initialize() {
        const today = moment().format('YYYY-MM-DD');
        const incoming = this.data || {};

        const defaultSpecies = this.species[0] || '';

        const defaults = {
            species: defaultSpecies,
            species_txt: '',
            num: 0,
            date: today,
            in_date: today,
            pre_date: today,
            pre_in_date: today,
            week: '',
            pre_week: '',
            pre_farm: '',
            type: 'in'
        };

        this.form = {
            ...defaults,
            ...incoming,
            date: incoming.date ? moment(incoming.date).format('YYYY-MM-DD') : today,
            in_date: incoming.in_date ? moment(incoming.in_date).format('YYYY-MM-DD') : today,
            pre_date: incoming.pre_date ? moment(incoming.pre_date).format('YYYY-MM-DD') : today,
            pre_in_date: incoming.pre_in_date ? moment(incoming.pre_in_date).format('YYYY-MM-DD') : today,
        };

        if (this.form.species && this.species.length > 0 && !this.species.includes(this.form.species)) {
            this.form.species_txt = this.form.species;
            this.form.species = 'direct';
        }
    }

    private showModal(message: string) {
        this.modalMessage.open({ message });
    }

    private closeWithAnimation(value: any) {
        if (this.closing) return;
        this.closing = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.closed.emit(value);
        }, 150);
    }

    public async register() {
        if (!this.form.num || this.form.num <= 0) {
            this.showModal("0 이상의 개체수를 입력해주세요.");
            return;
        }

        let result = { ...this.form };

        if (result.species === 'direct') {
            result.species = result.species_txt || '';
        }

        delete result.species_txt;

        result.date = moment(result.date).format('YYYY-MM-DD');
        result.in_date = moment(result.in_date).format('YYYY-MM-DD');
        result.pre_date = moment(result.pre_date).format('YYYY-MM-DD');
        result.pre_in_date = moment(result.pre_in_date).format('YYYY-MM-DD');

        this.closeWithAnimation(result);
    }

    public cancel() {
        this.closeWithAnimation(null);
    }
}

export default PortalFarmWidgetModalCageInComponent;